function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import hideVisually from 'polished/lib/mixins/hideVisually';
var useStyles = _ref => {
  var {
    isHeadRow,
    isSinglePage,
    selected,
    showAvatar,
    showFilters,
    theme,
    isAvatar
  } = _ref;
  return React.useMemo(() => {
    var headRowVerticalPadding = '2px';
    var isHeadRowWithFilters = isHeadRow && showFilters;
    return {
      root: {
        boxSizing: 'border-box',
        display: 'table-cell',
        maxWidth: '52px',
        minWidth: '52px',
        padding: theme.orbitalTwo,
        paddingBottom: isHeadRowWithFilters ? headRowVerticalPadding : undefined,
        paddingTop: isHeadRowWithFilters ? "calc(".concat(theme.orbitalTwo, " + ").concat(headRowVerticalPadding, ")") : undefined,
        verticalAlign: 'inherit',
        whiteSpace: 'nowrap',
        width: isSinglePage ? '52px' : '1%',
        '.vn-tooltip[data-placement="top"]': {
          margin: "calc(".concat(theme.layout.size1, " - 1px) ").concat(theme.layout.size1, " 0px !important")
        }
      },
      flex: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        maxWidth: "calc(52px - ".concat(theme.orbitalFour, ")")
      },
      avatar: _objectSpread({}, selected && _objectSpread({}, hideVisually())),
      checkbox: _objectSpread(_objectSpread(_objectSpread({}, isAvatar && !selected && _objectSpread({}, hideVisually())), !showAvatar && {
        clip: 'auto',
        clipPath: 'none',
        height: 'auto',
        overflow: 'visible',
        position: 'static',
        width: 'auto',
        whiteSpace: 'inherit'
      }), {}, {
        margin: "".concat(theme.orbitalOne, " calc(").concat(theme.orbitalThree, "/2)"),
        verticalAlign: 'inherit'
      }),
      tooltipSpan: {
        '*': {
          pointerEvents: 'none'
        }
      }
    };
  }, [isHeadRow, isSinglePage, selected, showAvatar, showFilters, theme, isAvatar]);
};
export default useStyles;